// extracted by mini-css-extract-plugin
module.exports = {"centerContainer":"cardImage_centerContainer__QRZ5n","flipperButton":"cardImage_flipperButton__mCvr_","fade-in":"cardImage_fade-in__PVMN5"};